import { type SystemStyleObject } from '@mui/system'
import { type Theme, type Sx } from '@dhl-ui/theme'

type MergedSx = readonly (boolean | SystemStyleObject<Theme> | ((theme: Theme) => SystemStyleObject<Theme>))[]

/**
 * Merging all SxProps correctly, so it can be array or functions etc
 */
export const mergeSx = (...sxProps: (Sx | false | undefined)[]): MergedSx =>
  (sxProps ?? [])
    .reduce<MergedSx>(
      (prev, currentValue) => [
        ...(Array.isArray(prev) ? prev : [prev]),
        ...(Array.isArray(currentValue) ? currentValue : [currentValue]),
      ],
      []
    )
    .filter(Boolean)

/**
 * Only allow some simple merging of props never functions nor arrays
 */
export function mergeSxObject<T extends object>(...sxProps: (T | undefined | false)[]): T {
  return Object.assign({}, ...sxProps.filter(Boolean)) as T
}
